"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogBodyContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../colors");
exports.DialogBodyContainer = styled_components_1.default.div `
  font-size: 12px;
  // text-align: right;

  background: ${colors_1.dialogBackgroundColor};

  padding: 10px 10px;

  > span {
    display: block;
    text-align: left;
  }
`;
//# sourceMappingURL=dialog-body-container.js.map